import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { PopupService } from '../../services/popup.service';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  standalone: false
})
export class PopupComponent implements OnInit, OnDestroy {
  data: any = null;
  private dataSub = new Subscription();

  constructor(public popup: PopupService) {}

  ngOnInit(): void {
    this.dataSub = this.popup.getPopupData().subscribe((data) => (this.data = data));
  }

  ngOnDestroy(): void {
    this.dataSub.unsubscribe();
  }
}
